import { doc, getDoc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../config/firebase';

class NotificationSettingsService {
  static async getSettings(userId = null) {
    try {
      const targetUserId = userId || auth.currentUser?.uid;
      if (!targetUserId) {
        console.error('No target user ID provided');
        throw new Error('User not authenticated');
      }

      console.log('=== Fetching Notification Settings ===');
      console.log('Target User ID:', targetUserId);

      const settingsDoc = await getDoc(doc(db, 'userSettings', targetUserId));
      
      const defaultSettings = {
        notifications: {
          enabled: false,
          messages: false,
          orders: false,
          marketing: false,
        }
      };

      if (!settingsDoc.exists()) {
        console.log('No settings document found - using defaults');
        console.log('Default settings:', JSON.stringify(defaultSettings, null, 2));
        
        if (!userId) {
          await setDoc(doc(db, 'userSettings', targetUserId), {
            ...defaultSettings,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp()
          });
        }
        return defaultSettings;
      }

      const existingSettings = settingsDoc.data();
      console.log('Existing settings:', JSON.stringify(existingSettings, null, 2));

      if (!existingSettings.notifications) {
        console.log('No notifications object in settings - using defaults');
        return defaultSettings;
      }

      const mergedSettings = {
        ...defaultSettings,
        ...existingSettings,
        notifications: {
          ...defaultSettings.notifications,
          ...existingSettings.notifications
        }
      };

      console.log('Final merged settings:', JSON.stringify(mergedSettings, null, 2));
      return mergedSettings;
    } catch (error) {
      console.error('Error in getSettings:', error);
      console.error('Stack:', error.stack);
      throw error;
    }
  }

  static async updateSettings(settings) {
    try {
      const userId = auth.currentUser?.uid;
      if (!userId) throw new Error('User not authenticated');

      console.log('Updating notification settings:', {
        userId,
        newSettings: settings
      });

      const settingsRef = doc(db, 'userSettings', userId);
      const currentDoc = await getDoc(settingsRef);

      if (!currentDoc.exists()) {
        console.log('Creating new settings document');
        await setDoc(settingsRef, {
          notifications: settings,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        });
      } else {
        console.log('Updating existing settings document');
        await updateDoc(settingsRef, {
          notifications: settings,
          updatedAt: serverTimestamp()
        });
      }

      // Verify the update
      const verifyDoc = await getDoc(settingsRef);
      console.log('Verified settings after update:', verifyDoc.data());

      return verifyDoc.data();
    } catch (error) {
      console.error('Error updating notification settings:', error);
      throw error;
    }
  }
}

export default NotificationSettingsService; 